import TopBar from '../topBar/TopBar';
import RaptorSnackbar from '../../feedback/raptorSnackbar/Snackbar.component';
import ControlBar from '../controlBar/ControlBar.component';
import { useSelector } from 'react-redux';
import { isControlBarShowingSelector } from '../../../redux/ui/controlbar/selectors';
import { RaidrKidsProvider } from '../../pages/raidr/kids/context/RaidrKidsContext';
import { Outlet } from 'react-router-dom';
import AuthenticatedPage from '../../../routes/utils/AuthenticatedPage';

const RAIDRLayoutV2 = () => {
  const controlBarIsShowing = useSelector(isControlBarShowingSelector);

  return (
    <RaidrKidsProvider>
      <div className="flex min-h-screen flex-col overflow-hidden bg-background">
        <TopBar />
        {controlBarIsShowing && <ControlBar />}
        <main className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <div className="flex min-h-0 w-full flex-1 flex-col overflow-hidden p-2.5">
            <AuthenticatedPage Component={Outlet} hardSection="raidr-v2" />
          </div>
        </main>
        <RaptorSnackbar />
      </div>
    </RaidrKidsProvider>
  );
};
export default RAIDRLayoutV2;
